import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSidebarLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinejoin: "round",
	strokeMiterlimit: 2,
	clipRule: "evenodd",
	viewBox: "0 0 59 59",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M52.587 54.786H6.416A6.42 6.42 0 0 1-.003 48.37V10.63a6.42 6.42 0 0 1 6.419-6.416h46.17A6.42 6.42 0 0 1 59 10.63v37.74a6.42 6.42 0 0 1-6.413 6.416m0-4.001a2.417 2.417 0 0 0 2.415-2.415V10.63a2.417 2.417 0 0 0-2.415-2.415H20.509v42.57z"
	})
});
export default SvgIconSidebarLeft;
